export default {
  setCollections: (state, payload) => { state.collections = payload },
  setCollection: (state, payload) => { state.collection = payload },
}